/*
 * LandingPage Messages
 *
 * This contains all the text for the LandingPage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  there_always_be_help: {
    id: 'app.containers.LandingPage.there_always_be_help',
    defaultMessage: 'Selalu Ada Bantuan'
  },
  facing_law_issue: {
    id: 'app.containers.LandingPage.facing_law_issue',
    defaultMessage: 'Hadapi Masalah Hukum'
  },
  thousands_of_users_consult: {
    id: 'app.containers.LandingPage.thousands_of_users_consult',
    defaultMessage: '15.000+ pengguna telah melakukan konsultasi dengan advokat kami'
  },
  consult_easier: {
    id: 'app.containers.LandingPage.consult_easier',
    defaultMessage: 'Konsultasi chat lebih mudah, aman dan nyaman'
  },
  experienced_lawyers: {
    id: 'app.containers.LandingPage.experienced_lawyers',
    defaultMessage: 'Advokat berbagai keahlian dalam satu platform'
  },
  consultation_30_minutes: {
    id: 'app.containers.LandingPage.consultation_30_minutes',
    defaultMessage: '30 Menit Konsultasi via Chat'
  },
  starts_from: {
    id: 'app.containers.LandingPage.starts_from',
    defaultMessage: 'Mulai dari'
  },
  cta: {
    id: 'app.containers.LandingPage.cta',
    defaultMessage: 'Chat Sekarang'
  },
});
